import { AfterViewInit, Component, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';

import { AdvisoryModel, GetAdvisoryModelsUseCaseService, GetContractUseCase, UpdateContractUseCase } from '../../../../core';
import { BasePage } from '../../base.page';
import { Contract } from '../../../domain/data';
import { ContractPage } from '../contract.page';
import { ErrorDialog } from '../../../ui/dialog/error/error.dialog';
import { LocalStorage } from '../../../client/helpers/local-storage';
import { MainRoutes } from '../../../main-routes.enum';
import { ParentEvents } from '../../../utils/parent-events.service';

@Component({
    templateUrl: './contract-advice.page.html',
    styleUrls: ['./contract-advice.page.scss'],
})
export class ContractAdvicePage extends BasePage implements AfterViewInit, OnInit, OnDestroy {
    public AdvisoryModel: typeof AdvisoryModel = AdvisoryModel;

    private contract: Contract;
    public visible = false;

    constructor(
        contractPage: ContractPage,
        parentEvents: ParentEvents,
        private dialog: MatDialog,
        private getContractUseCase: GetContractUseCase,
        private getAdvisoryModelsUseCaseService: GetAdvisoryModelsUseCaseService,
        private renderer: Renderer2,
        private router: Router,
        private updateContractUseCase: UpdateContractUseCase,
        private localStorage: LocalStorage
    ) {
        super(parentEvents);
        contractPage.hideBackButton();
    }

    ngOnInit() {
        this.getContract();
        this.renderer.addClass(document.body, 'bg-blue-gradient');
    }

    private getContract() {
        this.getContractUseCase.bind().subscribe((transaction) => {
            if (transaction.isSuccess) {
                this.contract = transaction.data as Contract;
                if (this.contract.isAdvisoryModelSuitabilityOrGDC()) {
                    this.parentEvents.cancel();
                } else if (this.localStorage.advisoryModel === AdvisoryModel.G) {
                    this.onClick(AdvisoryModel.G);
                } else {
                    this.visible = true;
                    this.getAdvisoryModels();
                }
            } else if (!transaction.isAuthError) {
                this.dialog.open(ErrorDialog);
            }
        });
    }

    private getAdvisoryModels() {
        this.getAdvisoryModelsUseCaseService.bind().subscribe((transaction) => {
            if (transaction.isSuccess) {
                const advisoryModels = transaction.data.filter(
                    (advisoryModel) => advisoryModel === AdvisoryModel.P || advisoryModel === AdvisoryModel.A
                );

                if (advisoryModels.length === 1) {
                    this.onClick(advisoryModels[0]);
                }
            } else if (!transaction.isAuthError) {
                this.dialog.open(ErrorDialog);
            }
        });
    }

    ngOnDestroy() {
        this.renderer.removeClass(document.body, 'bg-blue-gradient');
    }

    onClick(model: AdvisoryModel) {
        this.contract.convertToAdvisoryModel(model);
        this.updateContractUseCase.bind({ contract: this.contract }).subscribe((transaction) => {
            if (transaction.isSuccess) {
                this.router.navigateByUrl(MainRoutes.NEW_CONTRACT_SIGN);
            } else if (!transaction.isAuthError) {
                this.dialog.open(ErrorDialog);
            }
        });
    }
}
